import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { formatBlogDate } from "./blogUtils";

export default function BlogCard({ post }) {
  const { t, i18n } = useTranslation();
  const category = post.categories?.[0];

  return (
    <Link
      to={`/blog/${post.slug}`}
      className="group h-full bg-white rounded-3xl overflow-hidden shadow-[0_8px_30px_rgba(0,0,0,0.04)] hover:shadow-[0_20px_40px_rgba(0,0,0,0.12)] border border-gray-100 transition-all duration-500 flex flex-col hover:-translate-y-2"
    >
      <div className="relative h-[220px] overflow-hidden bg-gray-100">
        {post.cover_image && (
          <img
            src={post.cover_image}
            alt={post.title}
            loading="lazy"
            className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
          />
        )}
        <div className="absolute inset-0 bg-gradient-to-t from-[#0b0f19]/70 via-transparent to-transparent opacity-60 group-hover:opacity-80 transition-opacity duration-500" />
        {category && (
          <span className="absolute top-4 left-4 px-3 py-1.5 rounded-full bg-white/90 backdrop-blur-md text-[#0b0f19] text-[10px] font-bold uppercase tracking-wider shadow-lg">
            {category.name}
          </span>
        )}
      </div>

      <div className="p-6 md:p-8 flex flex-col flex-grow">
        <div className="flex items-center gap-3 mb-4 text-[11px] font-bold uppercase tracking-wider text-gray-400">
          <span>{formatBlogDate(post.published_at, i18n.language)}</span>
          {post.reading_time_minutes && (
            <>
              <span className="w-1 h-1 rounded-full bg-gray-300" />
              <span>{t("blogPage.minRead", { count: Number(post.reading_time_minutes) })}</span>
            </>
          )}
        </div>

        <h3 className="font-bold text-xl md:text-2xl text-[#0b0f19] mb-3 leading-tight group-hover:text-primary transition-colors line-clamp-2">
          {post.title}
        </h3>

        {post.excerpt && (
          <p className="text-gray-500 text-sm leading-relaxed mb-6 line-clamp-3 flex-grow">{post.excerpt}</p>
        )}

        <span className="mt-auto pt-5 border-t border-gray-100 inline-flex items-center gap-2 text-sm font-bold text-[#0b0f19] group-hover:text-primary transition-colors">
          {t("blogPage.readArticle")}
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="w-4 h-4 transition-transform group-hover:translate-x-1">
            <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3" />
          </svg>
        </span>
      </div>
    </Link>
  );
}
